'use strict';

angular.module('webAgro1App').filter('convertM2ToHa', function(CalculationService) {
  return function(value) {
    if (value) {
      return CalculationService.convertM2ForHa(value);
    }
  };
});
